import { render, staticRenderFns } from "./ResetPhone.vue?vue&type=template&id=5262d26e&scoped=true"
import script from "./ResetPhone.vue?vue&type=script&lang=js"
export * from "./ResetPhone.vue?vue&type=script&lang=js"
import style0 from "./ResetPhone.vue?vue&type=style&index=0&id=5262d26e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5262d26e",
  null
  
)

export default component.exports